import React from "react";
import { Card, Field, Input, Btn } from "@/components/erp/ui";
import { Plus, Trash2 } from "lucide-react";

const F = [["office_name", "Nama Cabang"], ["hours", "Jam Operasional"], ["address", "Alamat", 2], ["lat", "Latitude"], ["lng", "Longitude"], ["phone", "No. WhatsApp"], ["email", "Email"], ["max_per_hour", "Maks. kunjungan / jam", 1, "number"]];
const blank = () => ({ id: `br_${Math.random().toString(36).slice(2, 9)}`, office_name: "", hours: "", address: "", lat: "", lng: "", phone: "", email: "", max_per_hour: 2 });

// Cabang tambahan (cabang utama = form Lokasi di atas). Bila ada >1 lokasi, pengunjung memilih cabang saat booking.
export const BranchesEditor = ({ bkg, setBkg }) => {
  const list = bkg.branches || [];
  const set = (i, k, v) => setBkg({ ...bkg, branches: list.map((b, j) => (j === i ? { ...b, [k]: v } : b)) });
  return (
    <div className="space-y-3 mt-4 max-w-2xl" data-testid="branches-editor">
      {list.map((b, i) => (
        <Card key={b.id} className="p-5" data-testid={`branch-card-${i}`}>
          <div className="flex items-center justify-between mb-3">
            <h4 className="font-head font-semibold text-sm">Cabang {i + 2}</h4>
            <button data-testid={`branch-del-${i}`} onClick={() => setBkg({ ...bkg, branches: list.filter((_, j) => j !== i) })} className="text-slate-400 hover:text-rose-500"><Trash2 className="w-4 h-4" /></button>
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            {F.map(([k, l, span, type]) => (
              <div key={k} className={span === 2 ? "sm:col-span-2" : ""}><Field label={l}><Input type={type || "text"} data-testid={`branch-${k}-${i}`} value={b[k] ?? ""} onChange={(e) => set(i, k, e.target.value)} /></Field></div>
            ))}
          </div>
        </Card>
      ))}
      <Btn variant="ghost" data-testid="branch-add-btn" onClick={() => setBkg({ ...bkg, branches: [...list, blank()] })}><Plus className="w-4 h-4" /> Tambah Cabang</Btn>
      <p className="text-xs text-slate-400">Saat ini {list.length + 1} lokasi. Jika lebih dari 1, halaman Booking publik menampilkan pilihan cabang. Klik "Simpan Lokasi Booking" untuk menyimpan.</p>
    </div>
  );
};
